(function () {

    'use strict';

    angular.module('iplusjs.utils.format', [
        'lodash',
        'moment',
        'numbro',
        'iplusjs.utils.misc',
        'iplusjs.utils.identityType'
    ])
    .service('FormatUtilsService', FormatUtilsService);

    FormatUtilsService.$inject = [
        '$injector',
        'lodash',
        'moment',
        'numbro',
        'MiscUtilsService'
    ];
    function FormatUtilsService($injector, _, moment, numbro, MiscUtilsService) {
        var that = this,
            regexReplaceFormat = new RegExp(/\{(\d+)\}/g);

        that.regexWhitespaces = /\s/g;
        that.regexTelephone = /^[0-9-+\/\s()]*$/;
        that.regexEmail = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-zäüöÄÜÖß{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-zäüöÄÜÖß{|}~]+)*@[A-Za-z0-9äüöÄÜÖß]([A-Za-z0-9-äüöÄÜÖß]{0,61}[A-Za-z0-9äüöÄÜÖß])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
        that.regexMoney = / /;
        that.monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

        that.replace = replace;
        that.toBoolean = toBoolean;
        that.toBooleanString = toBooleanString;
        that.isBooleanString = isBooleanString;
        that.monthToMonthName = monthToMonthName;
        that.booleanToYesNo = booleanToYesNo;
        that.formatNumber = formatNumber;
        that.append = append;
        that.mask = mask;
        that.removeWhitespaces = removeWhitespaces;
        that.toAdresseString = toAdresseString;
        that.toPartnerString = toPartnerString;
        that.joinArrayByCondition = joinArrayByCondition;
        that.escapeRegExp = escapeRegExp;
        that.formatPhoneNumber = formatPhoneNumber;

        function _numberFormat(number, decimal, format) {
            if (isNaN(number) || number === null) {
                return '';
            }

            number = number.toFixed(~~decimal);

            return numbro(parseFloat(number)).format(format);
        }
        function replace() {
            var str = arguments[0],
                replacements = _.toArray(arguments).splice(1);

            if (MiscUtilsService.isEmpty(str)) {
                return str;
            }

            return str.replace(regexReplaceFormat, function (m, i) {
                return _.isNil(replacements[i]) ? m : replacements[i];
            });
        }
        function toBoolean(value) {
            if (MiscUtilsService.isEmpty(value)) {
                return;
            }

            var compareValue = _.isString(value) ? value.toLowerCase() : value,
                returnValue;

            if (compareValue === 'true' || compareValue === '1') {
                returnValue = true;
            } else if (compareValue === 'false' || compareValue === '0') {
                returnValue = false;
            } else {
                returnValue = !!compareValue;
            }

            return returnValue;
        }
        function toBooleanString(value) {
            if (!_.isBoolean(value)) {
                return;
            }

            return value ? 'true' : 'false';
        }
        function isBooleanString(value) {
            return _.includes(['true', 'false'], (_.isString(value) ? value : '').toLowerCase());
        }
        function monthToMonthName(month) {
            if (MiscUtilsService.isEmpty(month)) {
                return '';
            }

            var m = parseInt(month, 10);

            if (_.isNaN(m) || m < 1 || m > 12) {
                return '';
            }

            return that.monthNames[m - 1] || '';
        }
        function booleanToYesNo(value) {
            return (value === true || (_.isObjectLike(value) && _.isFunction(value.valueOf) && value.valueOf() === true)) ? 'Ja' : 'Nein';
        }
        function formatNumber(value, options) {
            options = options || {};

            options.decimal = options.decimal || 0;
            options.textPosition = options.textPosition || '+';
            options.format = options.format || '0,0';

            var decimal = options.decimal,
                format = options.format;

            value = parseFloat(value);

            if (options.showFractionsOnlyIfExists && options.decimal) {
                if (Math.round(value) === value) {
                    decimal = 0;
                }
            }

            if (decimal && format.indexOf('.') === -1) {
                format = format + '.' + _.repeat('0', decimal);
            }

            value = _numberFormat(value, decimal, format);

            if (!MiscUtilsService.isEmpty(options.text)) {
                value = options.textPosition === '+' ? value + ' ' + options.text : options.text + ' ' + value;
            }

            return value;
        }
        function append(string, appendedString, seperateSymbol) {
            seperateSymbol = seperateSymbol || '';
            appendedString = appendedString || '';

            if (MiscUtilsService.isEmpty(string) || !_.isString(string)) {
                return '';
            }

            return '' + string + seperateSymbol + appendedString;
        }
        function mask(value, maskString, options) {
            options = options || {};

            if (MiscUtilsService.isEmpty(maskString)) {
                return value;
            }

            var matchIndex = 0,
                valuesAsArray = _.toArray(value),
                maskedString,
                regexp;

            options.maskChar = options.maskChar || '*';

            regexp = new RegExp(escapeRegExp(options.maskChar), 'gi');

            maskedString = maskString.replace(regexp, function () {
                var idx = matchIndex++;
                return typeof valuesAsArray[idx] == 'undefined' ? '' : valuesAsArray[idx];
            });

            if (options.appendUnmasked) {
                maskedString += valuesAsArray.join('').substr(matchIndex);
            }

            return maskedString;
        }
        function removeWhitespaces(value) {
            if (!_.isString(value)) {
                return value;
            }

            return (value || '').replace(that.regexWhitespaces, '');
        }
        function toAdresseString(adresse, options) {
            options = options || {};
            options.style = options.style || 'multiline';
            options.lineBreak = options.lineBreak || '\n';
            options.country = options.country || 'long';

            if (MiscUtilsService.isEmpty(adresse) || !_.isObject(adresse)) {
                return '';
            }

            function _highlight(value, propertyName) {
                if (MiscUtilsService.isNotEmpty(value) && _.includes(options.highlightedProperties, propertyName)) {
                    return _.join([
                        '<strong>',
                        value,
                        '</strong>'
                    ], '');
                } else {
                    return value;
                }
            }

            return _.trim(_.compact([
                (_highlight(adresse.strasse, 'strasse') || '') + (options.style === 'singleline' ? ',' : ''),
                (options.country === 'short' ? _highlight(_.get(adresse.land, 'wert', ''), 'land') + '-' : '') + (_highlight(adresse.postleitzahl, 'postleitzahl') || '') + ' ' + (_highlight(adresse.ort, 'ort') || ''), //
                (options.country === 'long' ? _highlight(_.get(adresse.land, 'bezeichnung', ''), 'land') : '')
            ]).join(options.style === 'singleline' ? ' ' : options.lineBreak));
        }
        function toPartnerString(partner, props) {
            var partnerString,
                IdentityTypeUtilsService = $injector.get('IdentityTypeUtilsService'),
                properties = {
                    partnernummer: true,
                    anrede: true,
                    titel: true,
                    vorname: true,
                    nachname: true,
                    name2: false,
                    geburtsdatum: false
                };

            function _isConditionTrue(key) {
                return !!properties[key] && MiscUtilsService.isNotEmpty(partner[key]);
            }

            if (MiscUtilsService.isEmpty(partner) || !_.isObject(partner)) {
                return '';
            }

            _.merge(properties, _.isObject(props) ? props : null);

            partnerString = _.compact([
                _isConditionTrue('anrede') ? (_.get(partner.anrede, 'wert') !== '5' ? _.get(partner.anrede, 'bezeichnung', null) : null) : null,
                _isConditionTrue('titel') ? _.get(partner.titel, 'bezeichnung') : null,
                _isConditionTrue('vorname') ? partner.vorname : null,
                _isConditionTrue('name2') ? partner.nachname + (partner.name2 ? '\n' + partner.name2 : '') : _isConditionTrue('nachname') ? partner.nachname + (_isConditionTrue('geburtsdatum') ? ',' : '') : null,
                _isConditionTrue('geburtsdatum') ? moment(partner.geburtsdatum).format('DD.MM.YYYY') : null
            ]).join(' ');

            partnerString = (_isConditionTrue('partnernummer') ? IdentityTypeUtilsService.getFormatiert(partner.partnernummer) + '\n' : '') + partnerString;

            return partnerString;
        }
        function joinArrayByCondition(array, conditionsArray, joinStr) {
            if (MiscUtilsService.isAtLeastOneEmpty(array, conditionsArray)) {
                return;
            }

            return _.filter(array, function (value, index) {
                return !!conditionsArray[index];
            }).join(joinStr || '');
        }
        function escapeRegExp(str) {
            return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        }
        function formatPhoneNumber(phoneNumberStr, options) {
            options = options || {};

            if (MiscUtilsService.isEmpty(phoneNumberStr)) {
                return '';
            }

            var matchIntOrNat,
                matchBeginWithBrackets,
                retVal = phoneNumberStr,
                internationalCodeRemove = false;
            retVal = _.trim(retVal);

            matchIntOrNat = retVal.match(/((?:00|\+)\d{2})?([0-9-+\/\s()]*)/) || [];
            if (matchIntOrNat[1]) {
                if (options.removeInterantional) {
                    retVal = _.trimStart(matchIntOrNat[2] || '');
                    internationalCodeRemove = true;
                }
            } else if (!matchIntOrNat[1] && matchIntOrNat[2]) {
                if (options.internationalCode) {
                    retVal = [
                        options.internationalCode,
                        /^0{1}/.test(matchIntOrNat[2]) ? matchIntOrNat[2].substr(1) : matchIntOrNat[2]
                    ].join(' ');
                }
            }
            if (/^\(\d{1}\)/.test(retVal)) {
                matchBeginWithBrackets = retVal.match(/^(?:\()?(\d{0,1})(?:\)?)(?:\s)?([0-9-+\/\s()]*$)/);
                retVal = [
                    matchBeginWithBrackets[1],
                    matchBeginWithBrackets[2]
                ].join('');
            } else {
                if (internationalCodeRemove && !_.startsWith(retVal, '0')) {
                    retVal = '0' + retVal;
                }
            }
            if (options.replaceWhitespaceWithNonBreakingSpace) {
                retVal = _.replace(retVal, /\s/g, '&nbsp;');
            }

            return retVal;
        }

    }

})();
